import React from "react";
// import L from "leaflet";
import PropTypes from "prop-types";

// @material-ui/core components

import { Map, Marker, TileLayer } from "react-leaflet";

// const useStyles = makeStyles(styles);

export default function BaseMap(props) {
  // const classes = useStyles();
  // const { city, updateCity, attributes } = props;
  const restaurant = props.restaurant;

  return (
    <div>
      <link
        rel="stylesheet"
        href="https://unpkg.com/leaflet@1.1.0/dist/leaflet.css"
        // eslint-disable-next-line max-len
        integrity="sha512-wcw6ts8Anuw10Mzh9Ytw4pylW8+NAD4ch3lqm9lzAsTxg0GFeJgoAtxuCLREZSC5lUXdVyo/7yfsqFjQ4S+aKw=="
        crossOrigin=""
      />
      <script
        src="https://unpkg.com/leaflet@1.1.0/dist/leaflet.js"
        // eslint-disable-next-line max-len
        integrity="sha512-mNqn2Wg7tSToJhvHcqfzLMU6J4mkOImSPTxVZAdo+lcPlk+GhZmYgACEe0x35K7YzW1zJ7XyJV/TT1MrdXvMcA=="
        crossOrigin=""
      />
      <Map
        id={"cdc"}
        center={
          restaurant.location &&
          restaurant.location.coordinates &&
          restaurant.location.coordinates.length === 2
            ? [
                restaurant.location.coordinates[1],
                restaurant.location.coordinates[0]
              ]
            : [41.89193, 12.51133]
        }
        maxZoom={18}
        scrollWheelZoom={false}
        zoom={16}
        length={4}
        style={{
          width: "100%",
          height: "350px",
          overflow: "hidden"
        }}
      >
        <TileLayer
          attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
          url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
        />
        <Marker
          position={
            restaurant.location &&
            restaurant.location.coordinates &&
            restaurant.location.coordinates.length === 2
              ? [
                  restaurant.location.coordinates[1],
                  restaurant.location.coordinates[0]
                ]
              : [41.89193, 12.51133]
          }
        />
      </Map>
    </div>
  );
}

BaseMap.propTypes = {
  restaurant: PropTypes.object.isRequired
};
